import React from "react";
import Lv1SelectOptionBtn from "./Lv1SelectOptionBtn";
import { connect } from "react-redux";
import product from "../../../../models/product";
// CSS
import "../../../../css/LengthSection.css";

let $ = window.$;

class SubOptionLv1Section extends React.Component {
  state = {
    mouseOver: false,
    mouseOverLv1Name: null
  };

  componentDidMount = () => {
    const {
      changeLv1SelectOptionDefault,
      selectLv1Option,
      ui,
      activeOptionIndex
    } = this.props;
    const lv1OptionDefault = ui.options[activeOptionIndex].option.defaultShow;
    const defaultCode = lv1OptionDefault.lv1Code;

    if (lv1OptionDefault === undefined) return;
    //更新Lv2List
    selectLv1Option(defaultCode);
    changeLv1SelectOptionDefault(defaultCode);

    $(".length-option-btn").on("click", function () {
      $(".length-option-btn").removeClass("color-white");
      $(this).addClass("color-white");
    });
  };

  mouseOverLv1Name = lv1Name => {
    this.setState({
      mouseOver: true,
      mouseOverLv1Name: lv1Name
    });
  };

  mouseLeaveLv1Name = () => {
    this.setState({
      mouseOver: false
    });
  };

  render() {
    const { subOptionLv1List, lv1Default, subOptionLv1DisplayList } =
      this.props;
    const { mouseOver, mouseOverLv1Name } = this.state;
    const title = subOptionLv1List.title;
    const hasSubitems = subOptionLv1List.hasOwnProperty("subitems");
    const subItemsLength =
      (hasSubitems && subOptionLv1List.subitems.length) || 0;
    const lv1Name = subOptionLv1List.subitems.find(
      data => data.code === lv1Default
    );

    let component;
    let activeSubitem;
    let extraDescription = "";

    if (hasSubitems) {
      activeSubitem = subOptionLv1DisplayList.subitems.find(
        item => item.code === lv1Default
      );
      if (activeSubitem) {
        extraDescription = activeSubitem.extraDescription;
      }
      component = subOptionLv1List.subitems.map((item, index) => (
        <Lv1SelectOptionBtn
          key={index}
          index={index}
          name={item.name}
          value={item.code}
          default={item}
          type="lv1"
          mouseOverLv1Name={data => this.mouseOverLv1Name(data)}
          mouseLeaveLv1Name={() => this.mouseLeaveLv1Name()}
        />
      ));
    }

    return subItemsLength >= 1 ? (
      <div className="detailsSection ringMeasure_wrap  small-txt-link-wrap">
        <p className="subtitle">
          {/* <span style="text-transform: capitalize;">{title}</span> */}
          <span style={{ textTransform: "capitalize" }}>{title}</span>
        </p>
        <div className="optionBoxes">{component}</div>
        <div className="lv1-option-name">
          {/* 如果是MouseOver則顯示目前所觸碰到的選項，沒有的話就顯示目前已選取的選項 */}
          {mouseOver ? mouseOverLv1Name : lv1Name ? lv1Name.name : null}
        </div>
        <div>{extraDescription}</div>
      </div>
    ) : (
      ""
    );
  }
}
const mapStateToProps = state => {
  return {
    subOptionLv1DisplayList: state.product.subOptionLv1DisplayList,
    subOptionLv1List: state.product.subOptionLv1List,
    // lv1OptionDefault: state.product.ui.options.defaultShow,
    lv1Default: state.product.lv1Default,
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex
  };
};
const mapDispatchToProps = () => {
  return {
    selectLv1Option: index => product.actions.selectLv1Option(index),
    changeLv1SelectOptionDefault: data =>
      product.actions.changeLv1SelectOptionDefault(data)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubOptionLv1Section);
